import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useField, useFormikContext } from "formik";
import { useRequest } from "hooks";
import { IProductGroup, IProduct } from "model";
import { useMemo, useState } from "react";
import { MasterDataApiService } from "services";
import { I18nTranslator, translations } from "utils/i18n";

export const GroupSelect = () => {
  const [isGroupSelectOpen, setIsGroupSelectOpen] = useState<boolean>(false);
  const [request] = useState({});
  const { data: groups, loading: isLoadingGroup } = useRequest<
    any,
    IProductGroup[]
  >(request, MasterDataApiService.getAllProductGroup);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [__, ___, helper] = useField("groupId");
  const parentForm = useFormikContext<IProduct>();

  const selectedValue = useMemo(
    () => groups?.find((e) => e.id === parentForm.values.groupId) || {},
    [groups, parentForm.values.groupId]
  );

  return (
    <Autocomplete<Partial<IProductGroup>>
      id="groupId"
      open={isGroupSelectOpen}
      onOpen={() => {
        setIsGroupSelectOpen(true);
      }}
      onClose={() => {
        setIsGroupSelectOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name || ""}
      options={groups || []}
      filterOptions={(x) => x}
      loading={isLoadingGroup}
      onChange={(_, value) => {
        helper.setValue(value?.id);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={I18nTranslator(translations.masterData.productGroup)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoadingGroup ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      value={selectedValue}
    />
  );
};
